import {
    FETCH_CASH_COLLECTION_ORDER,
    FETCH_SALE_ORDER,
    RESET_CASH_COLLECTION_ORDER,
    RESET_SALE_ORDER,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
    others: {},
  };
  
  const cashCollectionView = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CASH_COLLECTION_ORDER:
        return { data: action.payload, others: action.others };
      case RESET_CASH_COLLECTION_ORDER:
        return initialState;
      default:
        return state;
    }
  };
  
  export default cashCollectionView;
  